import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { authClient } from "@core/clients";

const useGetTGVerificationToken = (options?: UseMutationOptions<{token: string}, any, void>) =>
  useMutation(
    ["get-tg-verification-token"],
    async () => {
      const data = await authClient.getTGVerificationToken();

      return data;
    },
    options
  );

export default useGetTGVerificationToken;
